import { Injectable, OnDestroy } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { map, tap } from 'rxjs/operators';
import { STATUS_INACTIVE } from 'src/app/app.constants';
import { UserService } from 'src/app/core/services/user.service';
import { AuthFirebaseService } from './auth-firebase.service';

@Injectable({
    providedIn: 'root'
})
export class AuthGuardService implements CanActivate, OnDestroy {
    private canActivateReturnUrl: string;

    constructor(
        private userService: UserService,
        private auth: AuthFirebaseService,
        private router: Router,
    ) {
    }

    ngOnDestroy(): void {
    }

    canActivate(next: ActivatedRouteSnapshot): Observable<boolean> {
        const permissions = next.data.permissions || [];
        this.canActivateReturnUrl = next.data.canActivateReturnUrl;
        return this.handlePermission().pipe(
            map(
                (havePermission) => {
                    if (havePermission && !this.hasAnyAuthority(permissions)) {
                        this.auth.signOut().subscribe();
                        this.redirectToSafeRoute();
                        return false;
                    }

                    if (!havePermission || !this.hasAnyAuthority(permissions)) {
                        this.router.navigateByUrl('/');
                        return false;
                    }

                    return true;
                }
            )
        );
    }

    handlePermission() {
        return this.userService.isLogged().pipe(
            tap((allowed) => {
                if (!allowed || this.loggedInUser.status === STATUS_INACTIVE) {
                    this.redirectToSafeRoute();
                }
            })
        );
    }

    hasAnyAuthority(permissions) {
        if (permissions.length) {
            return this.userService.hasAnyAuthority(permissions);
        }
        return true;
    }

    get loggedInUser() {
        return this.userService.getLoggedInUser();
    }

    redirectToSafeRoute() {
        this.router.navigate([this.canActivateReturnUrl]);
    }
}
